module.exports = __webpack_public_path__ + "img/1.b3cf731d.png";